import React from "react";
import AuthenticatedUserLayout from "../layouts/AuthenticatedUserLayout";
import {AuthorizedContextProvider} from "../context/AuthorizedContext";
import Container from "@material-ui/core/Container";
import {useTranslation} from "react-i18next";
import {Helmet} from "react-helmet";
import OverviewPageComponents from "../components/page-overview/OverviewPageComponents";

function OverviewPage() {


    const {t} = useTranslation();

    return (<AuthorizedContextProvider>

            <Helmet>
                <title>{t("page.title.welcome")}</title>
                <meta name="description" content={t("page.title.welcome")}/>
            </Helmet>

            <AuthenticatedUserLayout pageTitle={t("page.title.welcome")}>
                <Container>
                    <OverviewPageComponents/>
                </Container>
            </AuthenticatedUserLayout>
        </AuthorizedContextProvider>
    );


}

export default OverviewPage;
